import React from "react";

// Bootstrap
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

// Custom Components
import RotatingIcon from "../RotatingIcon";
import SectionTitle from "../SectionTitle";

// Icons
import {
    FaClipboardList,
    FaLaptop,
    FaNetworkWired,
    FaMobileAlt,
    FaMicrochip,
} from "react-icons/fa";

// React Scroll
import { Element } from "react-scroll";

import "./styles.css";

const Services = () => {
    const items = [
        {
            Icon: FaClipboardList,
            title: "Consultoria Tecnológica",
            content: "Sua ideia sendo posta em prática.",
        },
        {
            Icon: FaLaptop,
            title: "Sites",
            content:
                "Seus serviços de maneira objetiva e atraente para os seus clientes.",
        },
        {
            Icon: FaNetworkWired,
            title: "Sistemas Web",
            content: "Seu sistema acessível de qualquer lugar.",
        },
        {
            Icon: FaMobileAlt,
            title: "Aplicativos Mobile",
            content:
                "As mais diversas aplicações que rodam na palma da sua mão.",
        },
        {
            Icon: FaMicrochip,
            title: "Desenvolvimento de Pequenos Protótipos",
            content: "A interação entre o físico e o virtual.",
        },
    ];

    return (
        <Element name="services" className="services-section">
            <Container as="section" className="text-center">
                <Row>
                    <SectionTitle>Serviços</SectionTitle>
                    <p className="subtitle">
                        A EJEC oferece serviços de qualidade na área da
                        Engenharia de Computação com foco em desenvolvimento de
                        software, como sites, landing pages, blogs, sistemas de
                        gerenciamento e aplicativos. Também desenvolvemos
                        sistemas embarcados, de automação agrícola, residencial
                        e monitoramento de grandes áreas (redes de sensores).
                        Buscamos fornecer soluções eficientes e de baixo custo,
                        sempre visando a satisfação de nossos clientes.
                    </p>
                </Row>
                <Row className="items-row justify-content-center">
                    {items.map((item) => (
                        <Col
                            key={item.title}
                            sm="6"
                            md="4"
                            className="rotation-activator d-flex flex-column align-items-center"
                        >
                            <div>
                                <RotatingIcon
                                    size={{ width: "75px", height: "75px" }}
                                    title={item.title}
                                    Icon={item.Icon}
                                />
                            </div>
                            <div className="item-box-info">
                                <h4>{item.title}</h4>
                                <p>{item.content}</p>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </Element>
    );
};

export default Services;
